function updateNode(node: any, lang: any, untranslated: any) {
  if (!node.weglot) {
    const value: any = node.nodeValue;
    if (value && value.trim().length > 2) {
      untranslated.push(node);
    }
    return;
  }

  if (node.weglot?.content?.length === 0) {
    return;
  }

  if (
    node.weglot.content[0].translations &&
    node.weglot.content[0].translations[lang]
  ) {
    node.nodeValue = node.weglot.content[0].translations[lang];
    return;
  }

  if (node.weglot.content[0].original) {
    node.nodeValue = node.weglot.content[0].original;
  }
}

function checkNodesFromElem(query: any, lang: any, untranslated: any) {
  document.querySelectorAll(query).forEach(element => {
    element.childNodes.forEach((node: Node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        updateNode(node, lang, untranslated);
      }
    });
  });
}

function updateNodes(lang: string) {
  const untranslatedNodes: any[] = [];

  const tags = [
    'span',
    'p',
    'label',
    'strong',
    'a',
    'button',
    'h1',
    'h2',
    'h3',
  ];

  tags.forEach((tag: string) =>
    checkNodesFromElem(tag, lang, untranslatedNodes),
  );

  if (untranslatedNodes.length === 0 || !(window as any).Weglot) {
    return;
  }

  const textList: any[] = [];
  untranslatedNodes.forEach(n =>
    textList.push({ t: textList.length + 1, w: n.nodeValue }),
  );

  (window as any).Weglot.translate(
    { words: textList, languageTo: lang },
    function (data: any) {
      let index = 0;
      untranslatedNodes.forEach(n => {
        n.nodeValue = data[index];
        index++;
      });
    },
  );
}

export default defineNuxtRouteMiddleware((to, from) => {
  if (!process.client || !to || !from || !to.path || !from.path) {
    return;
  }

  const partsRouteFrom = from.path.split('/');

  const lang = partsRouteFrom.length > 1 ? partsRouteFrom[1] : null;
  if (!lang || lang.length !== 2 || lang === 'en') {
    return;
  }

  const isCurrentLanguageMatched = to.fullPath.indexOf('/' + lang) === 0;
  if (!isCurrentLanguageMatched) {
    useRouter().replace({ ...from, force: true });
    // workaround, to fix later
    setTimeout(() => {
      updateNodes(lang);
    }, 100);

    setTimeout(() => {
      updateNodes(lang);
    }, 600);
    setTimeout(() => {
      updateNodes(lang);
    }, 1100);
  }
});
